export const GET_COURSE = 'GET_COURSE';
export const COURSE_LOADING = 'COURSE_LOADING';
export const GET_COURSES = 'GET_COURSES';
export const COURSES_LOADING = 'COURSES_LOADING';
export const GET_COURSES_CATEGORIES = 'GET_COURSES_CATEGORIES';
export const GET_COURSES_LEVELS = 'GET_COURSES_LEVELS';
export const GET_COURSES_TYPES = 'GET_COURSES_TYPES';
export const TAXONOMIES_LOADING = 'TAXONOMIES_LOADING';
export const SET_COURSES_SEARCH_CRITERIA = 'SET_COURSES_SEARCH_CRITERIA';
export const RESET_COURSES_SEARCH_CRITERIA = 'RESET_COURSES_SEARCH_CRITERIA';
export const GET_OTHER_COURSES_CATEGORY = 'GET_OTHER_COURSES_CATEGORY';
export const OTHER_COURSES_CATEGORY_LOADING = 'OTHER_COURSES_CATEGORY_LOADING';
export const SIGNUP_TO_COURSE = 'SIGNUP_TO_COURSE';
export const SIGNOUT_FROM_COURSE = 'SIGNOUT_FROM_COURSE';
export const SIGNUPOROUT_TO_COURSE_LOADING = 'SIGNUPOROUT_TO_COURSE_LOADING';
export const SIGNUPOROUT_TO_COURSE_FAILURE = 'SIGNUPOROUT_TO_COURSE_FAILURE';
export const DASHBOARD_GET_COURSES_CHECKEDIN = 'DASHBOARD_GET_COURSES_CHECKEDIN';
export const DASHBOARD_GET_COURSES_AUTHOR = 'DASHBOARD_GET_COURSES_AUTHOR';
export const DASHBOARD_GET_COURSES_LOADING = 'DASHBOARD_GET_COURSES_LOADING';



// WEBPACK FOOTER //
// ./src/features/Courses/types.js